import { forwardRef } from "react";
import { IconInfo } from "src/components/icons-mui/info";
import { Button, type ButtonProps } from "src/components-mui/base/button/button";

// Color scheme map for icon button
const colorSchemeMap = {
    gray: { fill: "gray.100", color: "gray.800" },
    gray200: { fill: "gray.200", color: "gray.800" },
    black: { fill: "gray.800", color: "white" },
    orange: { fill: "orange.200", color: "orange.600" },
    blush: { fill: "blush.200", color: "blush.700" },
};

export type ColorSchemeMap = keyof typeof colorSchemeMap;

interface IIconPopoverInfoProps extends Omit<ButtonProps, "color"> {
    color?: ColorSchemeMap;
    ariaLabel: string;
}

export const PopoverButtonIconInfo = forwardRef<HTMLButtonElement, IIconPopoverInfoProps>(function PopoverButtonIconInfo(props, ref) {
    const { color = "gray", ariaLabel, sx, ...buttonProps } = props;
    const iconColors = colorSchemeMap[color];
    return (
        <Button ref={ref} variant="text" sx={{ minWidth: "auto", width: 16, height: 16, p: 0, ...sx }} {...buttonProps} aria-label={ariaLabel}>
            <IconInfo sx={{ color: iconColors.color, fill: iconColors.fill }} />
        </Button>
    );
});
